// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../resources/industry/oilGas.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../resources/industry/bankingFinancial.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../resources/industry/renewableEnergy.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../resources/industry/privateEquity.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../resources/industry/others.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Queries */
#IndustrySectionOne {
  background-color: #f7ebd7;
  height: auto !important;
  width: 100%;
  padding-top: 75px;
  scroll-snap-align: none !important;
  display: flex;
  flex-direction: row;
  position: relative;
  padding-bottom: 100px;
}

.IndustrySectionOne-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6%;
  padding-left: 175px;
  width: 57%;
}

#IndustrySectionOne-left-head {
  width: 100%;
  margin-top: 12%;
  font-size: 38px;
  font-weight: 500;
  line-height: 1.3em;
  margin-bottom: 30px;
}

#IndustrySectionOne-left-middle {
  display: flex;
  flex-direction: row;
  width: 80%;
}

#IndustrySectionOne-left-middle-left {
  text-align: justify;
  margin-left: -65px;
  font-size: 18px;
  line-height: 1.86;
  border-right: unset !important;
}

#IndustrySectionOne-discovermore {
  color: #ec6927;
  margin-top: 2%;
  cursor: pointer;
}

#IndustrySectionOne-left-middle-right {
  text-align: left;
  margin-left: 5%;
}

#IndustrySectionOne-left-middle-bottom {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 5%;
}

#IndustrySectionOne-schedule-a-demo {
  width: 130px;
  height: 33px;
  background: #ec6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  cursor: pointer;
}

#IndustrySectionOne-explore-how {
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  width: 25%;
  line-height: 16px;
}

.IndustrySectionOne-right {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: right;
}

#IndustrySectionOne-page1-banner {
  width: 100%;
}

#IndustrySectionOne-page1-video {
  position: absolute;
  margin-top: 50px;
}

.subtitle-video {
  font-weight: bold;
  margin-top: -50px;
}

#IndustrySectionOne-image-bg {
  margin-top: 75px;
}

.industry-image {
  width: 90%;
}

.industry-image:hover {
  cursor: pointer;
}

.IndustrySectionOne-Menu .ui.secondary.pointing.menu {
  height: 60px;
  justify-content: center;
  align-items: center;
  border-bottom: 3px solid #f7f7f7 !important;
  text-align: center;
}
.IndustrySectionOne-Menu .ui.secondary.pointing.menu .item {
  width: auto;
  height: 60px;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #1c2640 !important;
  opacity: 1 !important;
  margin: 0 25px;
}
.IndustrySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
  font-size: 18px !important;
  font-weight: 500;
  font-family: "Roboto", Roboto !important;
  color: #1c2640;
  line-height: 1.86;
  height: 55px;
  padding: inherit;
}
.IndustrySectionOne-Menu .ui.secondary.pointing.menu .item:hover {
  cursor: pointer;
}
.IndustrySectionOne-Menu .ui.secondary.pointing.menu .item:hover .ui.header {
  color: #ec7c45;
  border-bottom: 4px solid #ec7c45;
  transition: 0.4s;
}

.IndustrySectionOne-content-wrapper {
  background: #e2e6fb;
}
.IndustrySectionOne-content-wrapper .section-custom {
  height: auto;
  padding: 130px 150px 0 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left {
  width: 50%;
}
.IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left.custom {
  width: 70%;
  min-height: 250px;
}
.IndustrySectionOne-content-wrapper .section-custom .header {
  color: #fd7603;
  font-size: 38px;
  font-weight: 700;
  margin-left: 20px;
}
.IndustrySectionOne-content-wrapper .section-custom .txt-content {
  margin-top: 20px;
}
.IndustrySectionOne-content-wrapper .section-custom .txt-content ul li {
  font-size: 18px;
  line-height: 2.3em;
}
.IndustrySectionOne-content-wrapper .section-custom .txt-content.custom {
  font-size: 18px;
  margin-left: 22px;
  line-height: 1.8em;
  width: 80%;
}
.IndustrySectionOne-content-wrapper .section-custom .img-content {
  width: 600px;
}
.IndustrySectionOne-content-wrapper .section-custom .img-content-oil {
  padding-left: 10px;
}
.IndustrySectionOne-content-wrapper .section-custom .img-content-renew {
  margin-left: -70px;
}
.IndustrySectionOne-content-wrapper .section-custom .img-content-bank {
  margin-left: 20px;
}
.IndustrySectionOne-content-wrapper .section-custom .img-content-private {
  margin-left: -30px;
}
.IndustrySectionOne-content-wrapper .section-custom .img-content-custom {
  width: 500px;
}
.IndustrySectionOne-content-wrapper .section-custom .content-bank {
  margin-left: 10px;
}
.IndustrySectionOne-content-wrapper .section-custom .content-private {
  margin-left: 90px;
}
.IndustrySectionOne-content-wrapper .section-custom .discover-link {
  margin-top: 40px;
  margin-left: 40px;
}
.IndustrySectionOne-content-wrapper .section-custom .discover-link .text-linked {
  font-weight: 600;
  font-size: 16px;
  fill: #fd7603;
  color: #fd7603;
}
.IndustrySectionOne-content-wrapper #getContact {
  width: 100%;
  display: block;
}
.IndustrySectionOne-content-wrapper #getContact .txt-content.custom {
  width: 100%;
}
.IndustrySectionOne-content-wrapper #getContact .btn-contact-us {
  background: #1c2640;
  border: 2px solid #1c2640;
  border-radius: 3px;
  padding: 2px 20px;
  color: #fff;
  font-size: 16px;
  margin-left: 150px;
}
.IndustrySectionOne-content-wrapper #getContact .btn-contact-us:hover {
  cursor: pointer;
}

@media only screen and (min-width: 1281px) and (max-width: 1482px) {
  .IndustrySectionOne {
    padding: 200px 120px 100px !important;
  }
  .IndustrySectionOne .IndustrySectionOne-left {
    padding-left: 0;
    width: 50%;
    padding-right: 20px;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-head {
    margin-top: 0;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle {
    width: 100%;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle #IndustrySectionOne-left-middle-left {
    margin-left: 0;
  }
  .IndustrySectionOne .IndustrySectionOne-right .industry-image {
    width: 75%;
    margin-top: -160px;
  }
  .IndustrySectionOne-content-wrapper .section-custom {
    padding: 130px 120px 0;
    gap: 5%;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left, .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right {
    width: 50%;
  }
  .IndustrySectionOne-content-wrapper .section-custom .img-content {
    width: 100%;
    margin-left: 0;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-private {
    margin-left: 0;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left.custom {
    width: 70%;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left.custom .txt-content {
    display: flex;
    justify-content: space-between;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left.custom .txt-content .btn-contact-us {
    margin-left: 0 !important;
  }
}
@media only screen and (min-width: 280px) and (max-width: 482px), only screen and (min-width: 482px) and (max-width: 599px), only screen and (min-width: 482px) and (max-width: 666px) {
  .IndustrySectionOne {
    display: flex !important;
    padding: 0px !important;
    flex-direction: column !important;
  }
  .IndustrySectionOne .IndustrySectionOne-left {
    display: block !important;
    width: 100%;
    padding: 60px 30px;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-head {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 40px;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle {
    display: block !important;
    width: 100%;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle #IndustrySectionOne-left-middle-left {
    margin-left: 0px;
    font-size: 14px;
    line-height: 1.8;
  }
  .IndustrySectionOne .IndustrySectionOne-right {
    display: flex;
    position: relative !important;
    width: 100%;
    height: 230px;
    float: right;
    justify-content: flex-end;
    align-items: end;
    background: #f7ebd7;
  }
  .IndustrySectionOne .IndustrySectionOne-right div {
    padding: 0px 30px 10px 10px;
    background-color: #f7ebd7;
  }
  .IndustrySectionOne .IndustrySectionOne-right div .industry-image {
    width: 100%;
    height: 250px;
    text-align: right;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu {
    height: auto !important;
    background: #f7ebd7;
    border-bottom: unset !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item:hover .ui.header {
    color: #ec7c45;
    border-bottom: unset;
    transition: 0.4s;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item:hover .ui.header:before {
    content: "";
    border: solid #ec7c45;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin-right: 10px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item {
    width: 100%;
    text-align: left;
    border-bottom: 2px solid #bcbcbc;
    padding: 0.6em 0px;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
    font-size: 14px !important;
    height: auto !important;
    border-radius: 5px;
    line-height: 1;
    color: #1c2640;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header:before {
    content: "";
    border: solid #1c2640;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin-right: 10px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  .IndustrySectionOne-content-wrapper {
    padding: 10px 30px;
  }
  .IndustrySectionOne-content-wrapper .section-custom {
    display: flex !important;
    padding: 0px;
    margin: 30px 0px 10%;
    background: #fff;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left {
    width: 100%;
    margin-left: 0px !important;
    padding: 20px !important;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right {
    width: 100%;
    margin-left: 0px !important;
    padding: 20px !important;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left.custom {
    width: 100%;
    min-height: unset;
  }
  .IndustrySectionOne-content-wrapper .section-custom .img-content, .IndustrySectionOne-content-wrapper .section-custom .img-content-custom {
    width: 100%;
    padding: 0px !important;
    margin: 0px !important;
  }
  .IndustrySectionOne-content-wrapper .section-custom .header {
    font-size: 18px;
    margin-left: 0px;
    line-height: 1.2;
  }
  .IndustrySectionOne-content-wrapper .section-custom .txt-content {
    margin-top: 10px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .txt-content ul li {
    font-size: 14px;
    line-height: 1.8;
  }
  .IndustrySectionOne-content-wrapper .section-custom .txt-content.custom {
    font-size: 14px;
    margin-left: 0px;
    line-height: 1.8;
    width: 100%;
  }
  .IndustrySectionOne-content-wrapper .section-custom .discover-link {
    margin: 0px !important;
  }
  .IndustrySectionOne-content-wrapper .section-custom .discover-link .text-linked {
    font-size: 14px;
  }
  .IndustrySectionOne-content-wrapper #oilAndGas, .IndustrySectionOne-content-wrapper #bankingServices, .IndustrySectionOne-content-wrapper #others {
    flex-direction: column-reverse;
  }
  .IndustrySectionOne-content-wrapper #oilAndGas .content-wrapper-right, .IndustrySectionOne-content-wrapper #bankingServices .content-wrapper-right, .IndustrySectionOne-content-wrapper #others .content-wrapper-right {
    height: 250px;
    background-size: 130%;
    background-repeat: no-repeat;
    background-position: center;
  }
  .IndustrySectionOne-content-wrapper #oilAndGas .content-wrapper-left, .IndustrySectionOne-content-wrapper #bankingServices .content-wrapper-left, .IndustrySectionOne-content-wrapper #others .content-wrapper-left {
    box-shadow: 0px 5px 7px 0 rgba(36, 50, 66, 0.1411764706);
  }
  .IndustrySectionOne-content-wrapper #oilAndGas .img-content, .IndustrySectionOne-content-wrapper #bankingServices .img-content, .IndustrySectionOne-content-wrapper #others .img-content {
    display: none;
  }
  .IndustrySectionOne-content-wrapper #renewableEnergy, .IndustrySectionOne-content-wrapper #privateEquity {
    flex-direction: column;
  }
  .IndustrySectionOne-content-wrapper #renewableEnergy .content-wrapper-left, .IndustrySectionOne-content-wrapper #privateEquity .content-wrapper-left {
    height: 250px;
    background-size: 130%;
    background-repeat: no-repeat;
    background-position: center;
  }
  .IndustrySectionOne-content-wrapper #renewableEnergy .content-wrapper-right, .IndustrySectionOne-content-wrapper #privateEquity .content-wrapper-right {
    box-shadow: 0px 5px 7px 0 rgba(36, 50, 66, 0.1411764706);
  }
  .IndustrySectionOne-content-wrapper #renewableEnergy .img-content, .IndustrySectionOne-content-wrapper #privateEquity .img-content {
    display: none;
  }
  .IndustrySectionOne-content-wrapper #oilAndGas .content-wrapper-right {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  .IndustrySectionOne-content-wrapper #bankingServices .content-wrapper-right {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  .IndustrySectionOne-content-wrapper #renewableEnergy .content-wrapper-left {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  .IndustrySectionOne-content-wrapper #privateEquity .content-wrapper-left {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  .IndustrySectionOne-content-wrapper #others .content-wrapper-right {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  .IndustrySectionOne-content-wrapper #others .content-wrapper-right .img-content-custom {
    display: none;
  }
  .IndustrySectionOne-content-wrapper #getContact {
    background: #e2e6fb !important;
    padding: 0;
    text-align: center;
    margin: 40px 0px !important;
  }
  .IndustrySectionOne-content-wrapper #getContact .txt-content.custom {
    width: 100%;
    display: grid !important;
  }
  .IndustrySectionOne-content-wrapper #getContact .txt-content.custom .btn-contact-us {
    margin: 30px 40px 0px 40px !important;
    font-size: 14px;
  }
}
@media only screen and (min-width: 667px) and (max-width: 900px), only screen and (min-width: 667px) and (max-width: 1023px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  .IndustrySectionOne {
    display: flex !important;
    padding: 0px !important;
    padding-bottom: 40px !important;
    flex-direction: column !important;
  }
  .IndustrySectionOne .IndustrySectionOne-left {
    display: block !important;
    width: 100%;
    padding: 60px 30px;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-head {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 40px;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle {
    display: block !important;
    width: 100%;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle #IndustrySectionOne-left-middle-left {
    margin-left: 0px;
    font-size: 16px;
    line-height: 1.8;
  }
  .IndustrySectionOne .IndustrySectionOne-right {
    display: flex;
    position: relative !important;
    width: 100%;
    height: 230px;
    float: right;
    justify-content: flex-end;
    align-items: end;
    background: #f7ebd7;
  }
  .IndustrySectionOne .IndustrySectionOne-right div {
    padding: 0px 30px 10px 10px;
    background-color: #f7ebd7;
  }
  .IndustrySectionOne .IndustrySectionOne-right div .industry-image {
    width: 100%;
    max-height: 250px;
    text-align: right;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu {
    overflow: auto;
    white-space: nowrap;
    overflow-y: hidden;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item {
    margin: 0 5px;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
    font-size: 16px !important;
  }
  .IndustrySectionOne-content-wrapper {
    padding: 1px 30px 0;
  }
  .IndustrySectionOne-content-wrapper .section-custom {
    padding: 100px 30px 0;
    justify-content: flex-start;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left .header {
    font-size: 24px;
    margin-left: 0;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left .txt-content {
    margin-top: 20px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left .txt-content ul {
    padding-left: 30px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left .txt-content ul li {
    font-size: 16px;
    line-height: 1.3;
    margin-bottom: 15px;
    font-weight: normal;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left .txt-content .discover-link {
    margin-top: 30px;
    margin-left: 0;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right {
    width: 50%;
    margin-left: 40px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right .img-content {
    width: 100%;
    max-width: 350px;
    max-height: 240px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right .header {
    font-size: 24px;
    margin-left: 0;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content {
    margin-top: 20px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content ul {
    padding-left: 30px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content ul li {
    font-size: 16px;
    line-height: 1.3;
    margin-bottom: 15px;
    font-weight: normal;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content .discover-link {
    margin-top: 30px;
    margin-left: 0;
  }
  .IndustrySectionOne-content-wrapper .section-custom .img-content-renew, .IndustrySectionOne-content-wrapper .section-custom .img-content-private, .IndustrySectionOne-content-wrapper .section-custom .img-content-custom {
    width: 100%;
    max-width: 350px;
    max-height: 240px;
    margin-left: -12px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .img-content-others {
    margin-left: 2px;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left.custom {
    width: 50%;
  }
  .IndustrySectionOne-content-wrapper .section-custom .content-wrapper-left.custom.getContact {
    width: 100%;
  }
  .IndustrySectionOne-content-wrapper .section-custom .txt-content.custom {
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 15px;
    font-weight: normal;
    margin-left: 0;
    width: 100%;
  }
  .IndustrySectionOne-content-wrapper .section-custom .img-content-oil, .IndustrySectionOne-content-wrapper .section-custom .img-content-bank, .IndustrySectionOne-content-wrapper .section-custom .content-bank {
    padding-left: 0;
    margin-left: 0;
  }
  .IndustrySectionOne-content-wrapper #getContact .txt-content.custom {
    display: flex;
    align-items: center;
  }
  .IndustrySectionOne-content-wrapper #getContact .txt-content.custom .btn-contact-us {
    margin-left: 50px;
    width: 75%;
    max-width: 130px;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1023px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  .IndustrySectionOne {
    display: flex !important;
    padding: 70px 30px 50px !important;
    flex-direction: row !important;
  }
  .IndustrySectionOne .IndustrySectionOne-left {
    width: 90%;
    padding: 0;
    margin-right: 30px;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-head {
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 40px;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle {
    display: block !important;
    width: 100%;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-middle #IndustrySectionOne-left-middle-left {
    margin-left: 0px;
    font-size: 16px;
    line-height: 1.8;
  }
  .IndustrySectionOne .IndustrySectionOne-right {
    display: flex;
    position: relative !important;
    margin-top: -2px !important;
    margin-right: -30px;
    width: 100%;
    height: auto;
    align-items: end;
    justify-content: flex-start;
    background: #f7ebd7;
  }
  .IndustrySectionOne .IndustrySectionOne-right div {
    padding: 0 !important;
    background-color: #f7ebd7;
  }
  .IndustrySectionOne .IndustrySectionOne-right div .industry-image {
    width: 100%;
    max-height: 300px;
    text-align: right;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1023px) {
  .IndustrySectionOne-content-wrapper .section-custom {
    padding: 100px 50px 0 !important;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1280px) {
  .IndustrySectionOne {
    padding: 80px 60px 50px !important;
  }
  .IndustrySectionOne .IndustrySectionOne-left #IndustrySectionOne-left-head {
    margin-top: 10%;
  }
  .IndustrySectionOne .IndustrySectionOne-right {
    margin-right: -60px !important;
  }
  .IndustrySectionOne .IndustrySectionOne-right div .industry-image {
    max-height: 330px !important;
  }
  .IndustrySectionOne-Menu .ui.secondary.pointing.menu .item {
    margin: 0 15px;
  }
  .IndustrySectionOne-content-wrapper .section-custom {
    padding: 100px 70px 0 !important;
  }
  .IndustrySectionOne-content-wrapper .content-wrapper-right {
    margin-left: 80px !important;
  }
  .IndustrySectionOne-content-wrapper .content-wrapper-right .img-content {
    max-width: 390px !important;
    max-height: 280px !important;
  }
  .IndustrySectionOne-content-wrapper .img-content-renew, .IndustrySectionOne-content-wrapper .img-content-private, .IndustrySectionOne-content-wrapper .img-content-custom {
    max-width: 390px !important;
    max-height: 280px !important;
  }
  .IndustrySectionOne-content-wrapper #getContact .txt-content.custom .btn-contact-us {
    margin-left: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/media-queries.scss","webpack://./src/components/Industry/SectionOne/sectionOne.scss"],"names":[],"mappings":"AAEA,kBAAA;ACCA;EACC,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,mBAAA;EACA,UAAA;AADD;;AAIA;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,UAAA;AADD;;AAIA;EACC,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AADD;;AAIA;EACC,cAAA;EACA,cAAA;EACA,eAAA;AADD;;AAGA;EACC,gBAAA;EACA,eAAA;AAAD;;AAGA;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;AAAD;;AAGA;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAAD;;AAGA;EACC,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;AAAD;;AAGA;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAAD;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,kBAAA;EACA,gBAAA;AAAD;;AAGA;EACC,iBAAA;EACA,iBAAA;AAAD;;AAGA;EACC,gBAAA;AAAD;;AAGA;EACC,UAAA;AAAD;;AAGA;EACC,eAAA;AAAD;;AAIC;EACC,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;EACG,kBAAA;AADL;AAIC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAFF;AAGE;EACC,0BAAA;EACA,gBAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AADH;AAKC;EACC,eAAA;AAHF;AAIE;EACC,cAAA;EACA,gCAAA;EACA,gBAAA;AAFH;;AAOA;EACC,mBAAA;AAJD;AAKC;EACC,YAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;AAKE;EACC,UAAA;AAHH;AAME;EACC,UAAA;EACA,iBAAA;AAJH;AAOE;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AALH;AAQE;EACC,gBAAA;AANH;AAQG;EACC,eAAA;EACA,kBAAA;AANJ;AAUE;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AARH;AAWE;EACC,YAAA;AATH;AAYE;EACC,kBAAA;AAVH;AAYE;EACC,kBAAA;AAVH;AAYE;EACC,iBAAA;AAVH;AAYE;EACC,kBAAA;AAVH;AAaE;EACC,YAAA;AAXH;AAcE;EACC,iBAAA;AAZH;AAcE;EACC,iBAAA;AAZH;AAeE;EACC,gBAAA;EACA,iBAAA;AAbH;AAcG;EACC,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAZJ;AAiBC;EACC,WAAA;EACA,cAAA;AAfF;AAgBE;EACC,WAAA;AAdH;AAgBE;EACC,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAdH;AAiBE;EACC,eAAA;AAfH;;ADhNI;ECuOH;IACC,qCAAA;EAnBA;EAoBA;IACC,eAAA;IACA,UAAA;IACA,mBAAA;EAlBD;EAmBC;IACC,aAAA;EAjBF;EAmBC;IACC,WAAA;EAjBF;EAkBE;IACC,cAAA;EAhBH;EAqBC;IACC,UAAA;IACA,kBAAA;EAnBF;EAwBA;IACC,sBAAA;IACA,OAAA;EAtBD;EAuBC;IACC,UAAA;EArBF;EAwBA;IACC,WAAA;IACA,cAAA;EAtBD;EAwBA;IACC,cAAA;EAtBD;EAwBA;IACC,UAAA;EAtBD;EAuBC;IACC,aAAA;IACG,8BAAA;EArBL;EAsBK;IACC,yBAAA;EApBN;AACF;ADhQI;EC0RH;IACC,wBAAA;IACA,uBAAA;IACA,iCAAA;EAvBA;EAwBA;IACC,yBAAA;IACG,WAAA;IACA,kBAAA;EAtBJ;EAuBC;IACI,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,gBAAA;EArBL;EAuBI;IACC,yBAAA;IACA,WAAA;EArBL;EAuBK;IACC,gBAAA;IACA,eAAA;IACA,gBAAA;EArBN;EAyBA;IACC,aAAA;IACG,6BAAA;IACA,WAAA;IACA,aAAA;IACA,YAAA;IACA,yBAAA;IACA,gBAAA;IACA,mBAAA;EAvBJ;EAwBC;IACC,2BAAA;IACA,yBAAA;EAtBF;EAuBE;IACC,WAAA;IACA,aAAA;IACA,iBAAA;EArBH;EA2BA;IACC,uBAAA;IACG,mBAAA;IACA,+BAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,aAAA;EAzBJ;EA2BK;IACC,cAAA;IACA,oBAAA;IACA,gBAAA;EAzBN;EA0BM;IACC,WAAA;IACA,qBAAA;IACA,yBAAA;IACA,qBAAA;IACA,YAAA;IACA,kBAAA;IACH,yBAAA;IACE,iCAAA;EAxBN;EA4BC;IACC,WAAA;IACG,gBAAA;IACA,gCAAA;IACA,kBAAA;EA1BL;EA2BE;IACC,0BAAA;IACG,uBAAA;IACA,kBAAA;IACA,cAAA;IACA,cAAA;EAzBN;EA0BM;IACC,WAAA;IACA,qBAAA;IACA,yBAAA;IACA,qBAAA;IACA,YAAA;IACA,kBAAA;IACH,yBAAA;IACE,iCAAA;EAxBN;EA+BD;IACC,kBAAA;EA7BA;EA8BA;IACC,wBAAA;IACA,YAAA;IACA,oBAAA;IACA,gBAAA;EA5BD;EA8BC;IACC,WAAA;IACA,2BAAA;IACA,wBAAA;EA5BF;EA8BC;IACC,WAAA;IACA,2BAAA;IACA,wBAAA;EA5BF;EA+BC;IACC,WAAA;IACG,iBAAA;EA7BL;EAgCC;IACI,WAAA;IACA,uBAAA;IACA,sBAAA;EA9BL;EAiCC;IACC,eAAA;IACA,gBAAA;IACA,gBAAA;EA/BF;EAkCC;IACC,gBAAA;EAhCF;EAkCE;IACC,eAAA;IACA,gBAAA;EAhCH;EAoCC;IACC,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;EAlCF;EAoCC;IACC,sBAAA;EAlCF;EAmCE;IACC,eAAA;EAjCH;EAqCA;IACC,8BAAA;EAnCD;EAoCC;IACC,aAAA;IACG,qBAAA;IACA,4BAAA;IACA,2BAAA;EAlCL;EAoCC;IACC,wDAAA;EAlCF;EAoCC;IACC,aAAA;EAlCF;EAsCA;IACC,sBAAA;EApCD;EAqCC;IACC,aAAA;IACG,qBAAA;IACA,4BAAA;IACA,2BAAA;EAnCL;EAqCC;IACC,wDAAA;EAnCF;EAqCC;IACC,aAAA;EAnCF;EAwCC;IACC,yDAAA;EAtCF;EA2CC;IACC,yDAAA;EAzCF;EA8CC;IACC,yDAAA;EA5CF;EAiDC;IACC,yDAAA;EA/CF;EAsDC;IACC,yDAAA;EApDF;EAqDE;IACC,aAAA;EAnDH;EAwDA;IACG,8BAAA;IACA,UAAA;IACA,kBAAA;IACA,2BAAA;EAtDH;EAuDG;IACE,WAAA;IACA,wBAAA;EArDL;EAsDK;IACC,qCAAA;IACA,eAAA;EApDN;AACF;ADhdI;EC2gBH;IACC,wBAAA;IACA,uBAAA;IACA,+BAAA;IACA,iCAAA;EAxDA;EAyDA;IACC,yBAAA;IACG,WAAA;IACA,kBAAA;EAvDJ;EAwDC;IACI,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,gBAAA;EAtDL;EAwDI;IACC,yBAAA;IACA,WAAA;EAtDL;EAwDK;IACC,gBAAA;IACA,eAAA;IACA,gBAAA;EAtDN;EA0DA;IACC,aAAA;IACG,6BAAA;IACA,WAAA;IACA,aAAA;IACA,YAAA;IACA,yBAAA;IACA,gBAAA;IACA,mBAAA;EAxDJ;EAyDC;IACC,2BAAA;IACA,yBAAA;EAvDF;EAwDE;IACC,WAAA;IACA,iBAAA;IACA,iBAAA;EAtDH;EA6DA;IACC,cAAA;IACG,mBAAA;IACA,kBAAA;EA3DJ;EA4DI;IACC,aAAA;EA1DL;EA2DK;IACC,0BAAA;EAzDN;EA+DD;IACC,mBAAA;EA7DA;EA8DA;IACC,qBAAA;IACA,2BAAA;EA5DD;EA8DE;IACC,eAAA;IACA,cAAA;EA5DH;EA8DE;IACC,gBAAA;EA5DH;EA6DG;IAAK,kBAAA;EA1DR;EA2DG;IACC,eAAA;IACG,gBAAA;IACA,mBAAA;IACA,mBAAA;EAzDP;EA2DG;IACC,gBAAA;IACA,cAAA;EAzDJ;EA6DC;IACC,UAAA;IACG,iBAAA;EA3DL;EA4DE;IACC,WAAA;IACA,gBAAA;IACG,iBAAA;EA1DN;EA4DE;IACC,eAAA;IACA,cAAA;EA1DH;EA4DE;IACC,gBAAA;EA1DH;EA2DG;IAAK,kBAAA;EAxDR;EAyDG;IACC,eAAA;IACG,gBAAA;IACA,mBAAA;IACA,mBAAA;EAvDP;EAyDG;IACC,gBAAA;IACA,cAAA;EAvDJ;EA2DC;IACC,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAzDF;EA2DC;IACC,gBAAA;EAzDF;EA2DC;IACC,UAAA;EAzDF;EA2DC;IACC,WAAA;EAzDF;EA2DC;IACC,eAAA;IACG,gBAAA;IACA,mBAAA;IACA,mBAAA;IACA,cAAA;IACA,WAAA;EAzDL;EA2DC;IACC,eAAA;IACA,cAAA;EAzDF;EA4DA;IACC,aAAA;IACA,mBAAA;EA1DD;EA2DC;IACC,iBAAA;IACA,UAAA;IACG,gBAAA;EAzDL;AACF;ADtmBI;ECqqBH;IACC,wBAAA;IACA,kCAAA;IACA,8BAAA;EA5DA;EA6DA;IACI,UAAA;IACA,UAAA;IACA,kBAAA;EA3DJ;EA4DC;IACI,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,gBAAA;EA1DL;EA4DI;IACC,yBAAA;IACA,WAAA;EA1DL;EA4DK;IACC,gBAAA;IACA,eAAA;IACA,gBAAA;EA1DN;EA8DA;IACC,aAAA;IACG,6BAAA;IACA,2BAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,2BAAA;IACA,mBAAA;EA5DJ;EA6DC;IACC,qBAAA;IACA,yBAAA;EA3DF;EA4DE;IACC,WAAA;IACA,iBAAA;IACA,iBAAA;EA1DH;AACF;ADrpBI;ECutBF;IACC,gCAAA;EA/DD;AACF;AD1pBI;EC+tBH;IACC,kCAAA;EAlEA;EAoEC;IACC,eAAA;EAlEF;EAqEA;IACC,8BAAA;EAnED;EAqEE;IACC,4BAAA;EAnEH;EAyED;IACC,cAAA;EAvEA;EA2EA;IACC,gCAAA;EAzED;EA2EA;IACC,4BAAA;EAzED;EA0EC;IACC,2BAAA;IACA,4BAAA;EAxEF;EA2EA;IACC,2BAAA;IACA,4BAAA;EAzED;EA2EA;IACC,kBAAA;EAzED;AACF","sourcesContent":["$size__site_content_width : 1024px;\n\n/* Media Queries */ \n\n$media_queries : (\n    'mobile360'         : unquote(\"only screen and (min-width: 280px) and (max-width: 400px)\"),\n    'xs'                : unquote(\"only screen and (min-width: 280px) and (max-width: 482px)\"),\n    'miniMobile'        : unquote(\"only screen and (min-width: 280px) and (max-width: 450px)\"),\n    'mediumMobile'      : unquote(\"only screen and (min-width: 450px) and (max-width: 482px)\"),\n    'eReaders'          : unquote(\"only screen and (min-width: 482px) and (max-width: 599px)\"),\n    'mobile'            : unquote(\"only screen and (min-width: 482px) and (max-width: 666px)\"),\n    'customMobile'      : unquote(\"only screen and (min-width: 600px) and (max-width: 900px)\"),\n    'miniTab'           : unquote(\"only screen and (min-width: 667px) and (max-width: 900px)\"),\n    'tablet'            : unquote(\"only screen and (min-width: 667px) and (max-width: 1023px)\"),\n    'customTablet'      : unquote(\"only screen and (min-width: 900px) and (max-width: 1023px)\"),\n    'wideTablet'        : unquote(\"only screen and (min-width: 1024px) and (max-width: 1280px)\"),\n    'miniDesktop'       : unquote(\"only screen and (min-width: 1281px) and (max-width: 1482px)\"),\n    'desktop'           : unquote(\"only screen and (min-width: 1025px)\"),\n    'wideScreens'       : unquote(\"only screen and (min-width: 1339px)\"),\n    'hdScreen'          : unquote(\"only screen and (min-width: 1800px)\"),\n    'retina2'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)\"),\n    'retina3'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 288dpi)\"),\n    'landscape'         : unquote(\"screen and (orientation:landscape)\"),    \n    'portrait'          : unquote(\"screen and (orientation:portrait)\")\n);\n\n@mixin devices($breakpoints) {\n    $conditions : ();\n    @each $breakpoint in $breakpoints {\n        // If the key exists in the map\n        $conditions: append(\n            $conditions,\n            #{inspect(map-get($media_queries, $breakpoint))},\n            comma\n        );\n    }\n\n    @media #{$conditions} {\n        @content;\n    }\n\n}\n","@import '../../../media-queries.scss';\n\n\n#IndustrySectionOne {\n\tbackground-color: #f7ebd7;\n\theight: auto !important;\n\twidth: 100%;\n\tpadding-top: 75px;\n\tscroll-snap-align: none !important;\n\tdisplay: flex;\n\tflex-direction: row;\n\tposition: relative;\n\tpadding-bottom: 100px;\n}\n\n.IndustrySectionOne-left {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 6%;\n\tpadding-left: 175px;\n\twidth: 57%;\n}\n\n#IndustrySectionOne-left-head {\n\twidth: 100%;\n\tmargin-top: 12%;\n\tfont-size: 38px;\n\tfont-weight: 500;\n\tline-height: 1.3em;\n\tmargin-bottom: 30px;\n}\n\n#IndustrySectionOne-left-middle {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 80%;\n}\n\n#IndustrySectionOne-left-middle-left {\n\ttext-align: justify;\n\tmargin-left: -65px;\n\tfont-size: 18px;\n\tline-height: 1.86;\n\tborder-right: unset !important;\n}\n\n#IndustrySectionOne-discovermore {\n\tcolor: #ec6927;\n\tmargin-top: 2%;\n\tcursor: pointer;\n}\n#IndustrySectionOne-left-middle-right {\n\ttext-align: left;\n\tmargin-left: 5%;\n}\n\n#IndustrySectionOne-left-middle-bottom {\n\twidth: 80%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: flex-start;\n\tgap: 5%;\n}\n\n#IndustrySectionOne-schedule-a-demo {\n\twidth: 130px;\n\theight: 33px;\n\tbackground: #ec6927;\n\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\tborder-radius: 3px;\n\tborder: none;\n\tcolor: white;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 13.5px;\n\tcursor: pointer;\n}\n\n#IndustrySectionOne-explore-how {\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 13.5px;\n\twidth: 25%;\n\tline-height: 16px;\n}\n\n.IndustrySectionOne-right {\n\twidth: 50%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: right;\n}\n\n#IndustrySectionOne-page1-banner {\n\twidth: 100%;\n}\n\n#IndustrySectionOne-page1-video {\n\tposition: absolute;\n\tmargin-top: 50px;\n}\n\n.subtitle-video {\n\tfont-weight: bold;\n\tmargin-top: -50px;\n}\n\n#IndustrySectionOne-image-bg {\n\tmargin-top: 75px;\n}\n\n.industry-image {\n\twidth: 90%;\n}\n\n.industry-image:hover {\n\tcursor: pointer;\n}\n\n.IndustrySectionOne-Menu {\n\t.ui.secondary.pointing.menu {\n\t\theight: 60px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-bottom: 3px solid #f7f7f7 !important;\n\t    text-align: center;\n\t}\n\n\t.ui.secondary.pointing.menu .item {\n\t\twidth: auto;\n\t\theight: 60px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t\tcolor: #1c2640 !important;\n\t\topacity: 1 !important;\n\t\tmargin: 0 25px;\n\t\t.ui.header {\n\t\t\tfont-size: 18px !important;\n\t\t\tfont-weight: 500;\n\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\tcolor: #1c2640;\n\t\t\tline-height: 1.86;\n\t\t\theight: 55px;\n\t\t\tpadding: inherit;\n\t\t}\n\t}\n\n\t.ui.secondary.pointing.menu .item:hover {\n\t\tcursor: pointer;\n\t\t.ui.header {\n\t\t\tcolor: #ec7c45;\n\t\t\tborder-bottom: 4px solid #ec7c45;\n\t\t\ttransition: 0.4s;\n\t\t}\n\t}\n}\n\n.IndustrySectionOne-content-wrapper {\n\tbackground: #e2e6fb;\n\t.section-custom {\n\t\theight: auto;\n\t\tpadding: 130px 150px 0 150px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t.content-wrapper-left {\n\t\t\twidth: 50%;\n\t\t}\n\n\t\t.content-wrapper-left.custom {\n\t\t\twidth: 70%;\n\t\t\tmin-height: 250px;\n\t\t}\n\n\t\t.header {\n\t\t\tcolor: #fd7603;\n\t\t\tfont-size: 38px;\n\t\t\tfont-weight: 700;\n\t\t\tmargin-left: 20px;\n\t\t}\n\n\t\t.txt-content {\n\t\t\tmargin-top: 20px;\n\n\t\t\tul li {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 2.3em;\n\t\t\t}\n\t\t}\n\n\t\t.txt-content.custom {\n\t\t\tfont-size: 18px;\n\t\t\tmargin-left: 22px;\n\t\t\tline-height: 1.8em;\n\t\t\twidth: 80%;\n\t\t}\n\n\t\t.img-content {\n\t\t\twidth: 600px;\n\t\t}\n\n\t\t.img-content-oil {\n\t\t\tpadding-left: 10px;\n\t\t}\n\t\t.img-content-renew {\n\t\t\tmargin-left: -70px;\n\t\t}\n\t\t.img-content-bank {\n\t\t\tmargin-left: 20px;\n\t\t}\n\t\t.img-content-private {\n\t\t\tmargin-left: -30px;\n\t\t}\n\n\t\t.img-content-custom {\n\t\t\twidth: 500px;\n\t\t}\n\n\t\t.content-bank {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t.content-private {\n\t\t\tmargin-left: 90px;\n\t\t}\n\n\t\t.discover-link {\n\t\t\tmargin-top: 40px;\n\t\t\tmargin-left: 40px;\n\t\t\t.text-linked {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfill: #fd7603;\n\t\t\t\tcolor: #fd7603;\n\t\t\t}\n\t\t}\n\t}\n\n\t#getContact {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t\t.txt-content.custom {\n\t\t\twidth: 100%;\n\t\t}\n\t\t.btn-contact-us {\n\t\t\tbackground: #1c2640;\n\t\t\tborder: 2px solid #1c2640;\n\t\t\tborder-radius: 3px;\n\t\t\tpadding: 2px 20px;\n\t\t\tcolor: #fff;\n\t\t\tfont-size: 16px;\n\t\t\tmargin-left: 150px;\n\t\t}\n\n\t\t.btn-contact-us:hover {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n\n//Responsive \n@include devices(miniDesktop) {\n\t.IndustrySectionOne {\n\t\tpadding: 200px 120px 100px !important;\n\t\t.IndustrySectionOne-left {\n\t\t\tpadding-left: 0;\n\t\t\twidth: 50%;\n\t\t\tpadding-right: 20px;\n\t\t\t#IndustrySectionOne-left-head {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t\t#IndustrySectionOne-left-middle {\n\t\t\t\twidth: 100%;\n\t\t\t\t#IndustrySectionOne-left-middle-left {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.IndustrySectionOne-right {\n\t\t\t.industry-image {\n\t\t\t\twidth: 75%;\n\t\t\t\tmargin-top: -160px;\n\t\t\t}\n\t\t}\n\t}\n\t.IndustrySectionOne-content-wrapper {\n\t\t.section-custom {\n\t\t\tpadding: 130px 120px 0;\n\t\t\tgap: 5%;\n\t\t\t.content-wrapper-left, .content-wrapper-right {\n\t\t\t\twidth: 50%;\n\t\t\t}\n\t\t}\n\t\t.section-custom .img-content {\n\t\t\twidth: 100%;\n\t\t\tmargin-left: 0;\n\t\t}\n\t\t.section-custom .content-private {\n\t\t\tmargin-left: 0;\n\t\t}\n\t\t.section-custom .content-wrapper-left.custom {\n\t\t\twidth: 70%;\n\t\t\t.txt-content {\n\t\t\t\tdisplay: flex;\n    \t\t\tjustify-content: space-between;\n    \t\t\t.btn-contact-us {\n    \t\t\t\tmargin-left: 0 !important;\n    \t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@include devices(xs eReaders mobile) {\n\t.IndustrySectionOne{\n\t\tdisplay: flex !important;\n\t\tpadding: 0px !important;\n\t\tflex-direction: column !important;\n\t\t.IndustrySectionOne-left{\n\t\t\tdisplay: block !important;\n\t\t    width: 100%;\n\t\t    padding: 60px 30px;\n\t\t\t#IndustrySectionOne-left-head{\n\t\t    \tfont-size: 24px;\n\t\t    \tfont-weight: 700;\n\t\t    \tmargin-bottom: 20px;\n\t\t    \tmargin-top: 40px;\n\t\t    }\n\t\t    #IndustrySectionOne-left-middle{\n\t\t    \tdisplay: block !important;\n\t\t\t    width: 100%;\n\t\t\t    \n\t\t\t    #IndustrySectionOne-left-middle-left {\n\t\t\t    \tmargin-left: 0px;\n\t\t\t    \tfont-size: 14px;\n\t\t\t    \tline-height: 1.8;\n\t\t\t    }\n\t\t    }\n\t\t}\n\t\t.IndustrySectionOne-right{\n\t\t\tdisplay: flex;\n\t\t    position: relative !important;\n\t\t    width: 100%;\n\t\t    height: 230px;\n\t\t    float: right;\n\t\t    justify-content: flex-end;\n\t\t    align-items: end;\n\t\t    background: #f7ebd7;\n\t\t\tdiv{\n\t\t\t\tpadding: 0px 30px 10px 10px;\n\t\t\t\tbackground-color: #f7ebd7;\n\t\t\t\t.industry-image {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 250px;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.IndustrySectionOne-Menu{\n\t\t.ui.secondary.pointing.menu{\n\t\t\theight: auto !important;\n\t\t    background: #f7ebd7;\n\t\t    border-bottom: unset !important;\n\t\t    display: flex;\n\t\t    flex-direction: column;\n\t\t    justify-content: center;\n    \t\talign-items: center;\n\t\t    padding: 30px;\n\t\t    .item:hover{\n\t\t    \t.ui.header {\n\t\t\t\t    color: #ec7c45;\n\t\t\t\t    border-bottom: unset;\n\t\t\t\t    transition: 0.4s;\n\t\t\t\t    &:before {\n\t\t\t\t\t    content: \"\";\n\t\t\t\t\t    border: solid #ec7c45;\n\t\t\t\t\t    border-width: 0 3px 3px 0;\n\t\t\t\t\t    display: inline-block;\n\t\t\t\t\t    padding: 3px;\n\t\t\t\t\t    margin-right: 10px;\n\t\t\t\t\t\ttransform: rotate(-45deg);\n  \t\t\t\t\t\t-webkit-transform: rotate(-45deg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t    }\n\t\t\t.item{\n\t\t\t\twidth: 100%;\n\t\t\t    text-align: left;\n\t\t\t    border-bottom: 2px solid #bcbcbc;\n\t\t\t    padding: 0.6em 0px;\n\t\t\t\t.ui.header{\n\t\t\t\t\tfont-size: 14px !important;\n\t\t\t\t    height: auto !important;\n\t\t\t\t    border-radius: 5px;\n\t\t\t\t    line-height: 1;\n\t\t\t\t    color: #1c2640;\n\t\t\t\t    &:before {\n\t\t\t\t    \tcontent: \"\";\n\t\t\t\t\t    border: solid #1c2640;\n\t\t\t\t\t    border-width: 0 3px 3px 0;\n\t\t\t\t\t    display: inline-block;\n\t\t\t\t\t    padding: 3px;\n\t\t\t\t\t    margin-right: 10px;\n\t\t\t\t\t\ttransform: rotate(-45deg);\n  \t\t\t\t\t\t-webkit-transform: rotate(-45deg);\n\t\t\t\t    }\n\t\t\t\t}\n\t\t\t} \n\t\t}\n\t}\n\n\t.IndustrySectionOne-content-wrapper{\n\t\tpadding: 10px 30px;\n\t\t.section-custom {\n\t\t\tdisplay: flex !important;\n\t\t\tpadding: 0px;\n\t\t\tmargin: 30px 0px 10%;\n\t\t\tbackground: #fff;\n\n\t\t\t.content-wrapper-left{\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-left: 0px !important;\n\t\t\t\tpadding: 20px !important;\n\t\t\t}\n\t\t\t.content-wrapper-right{\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-left: 0px !important;\n\t\t\t\tpadding: 20px !important;\n\t\t\t}\n\n\t\t\t.content-wrapper-left.custom{\n\t\t\t\twidth: 100%; \n    \t\t\tmin-height: unset;\n\t\t\t}\n\n\t\t\t.img-content,.img-content-custom {\n\t\t\t    width: 100%;\n\t\t\t    padding: 0px !important;\n\t\t\t    margin: 0px !important;\n\t\t\t}\n\n\t\t\t.header {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tmargin-left: 0px;\n\t\t\t\tline-height: 1.2;\n\t\t\t}\n\n\t\t\t.txt-content {\n\t\t\t\tmargin-top: 10px;\n\n\t\t\t\tul li {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 1.8;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.txt-content.custom {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tmargin-left: 0px;\n\t\t\t\tline-height: 1.8;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t.discover-link {\n\t\t\t\tmargin: 0px !important;\n\t\t\t\t.text-linked{\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t#oilAndGas , #bankingServices , #others {\n\t\t\tflex-direction: column-reverse;\n\t\t\t.content-wrapper-right{\n\t\t\t\theight: 250px;\n\t\t\t    background-size: 130%;\n\t\t\t    background-repeat: no-repeat;\n\t\t\t    background-position: center;\n\t\t\t}\n\t\t\t.content-wrapper-left{\n\t\t\t\tbox-shadow: 0px 5px 7px 0 #24324224;\n\t\t\t}\n\t\t\t.img-content{\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t#renewableEnergy, #privateEquity{\n\t\t\tflex-direction: column;\n\t\t\t.content-wrapper-left{\n\t\t\t\theight: 250px;\n\t\t\t    background-size: 130%;\n\t\t\t    background-repeat: no-repeat;\n\t\t\t    background-position: center;\n\t\t\t}\n\t\t\t.content-wrapper-right{\n\t\t\t\tbox-shadow: 0px 5px 7px 0 #24324224;\n\t\t\t}\n\t\t\t.img-content{\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t#oilAndGas{\n\t\t\t.content-wrapper-right{\n\t\t\t\tbackground-image: url('../../../resources/industry/oilGas.png');\n\t\t\t}\n\t\t}\n\n\t\t#bankingServices{\n\t\t\t.content-wrapper-right{\n\t\t\t\tbackground-image: url('../../../resources/industry/bankingFinancial.png');\n\t\t\t}\n\t\t}\n\n\t\t#renewableEnergy{\n\t\t\t.content-wrapper-left{\n\t\t\t\tbackground-image: url('../../../resources/industry/renewableEnergy.png');\n\t\t\t}\n\t\t}\n\n\t\t#privateEquity{\n\t\t\t.content-wrapper-left{\n\t\t\t\tbackground-image: url('../../../resources/industry/privateEquity.png');\n\t\t\t}\n\t\t}\n\n\t\n\n\t\t#others{\n\t\t\t.content-wrapper-right{\n\t\t\t\tbackground-image: url('../../../resources/industry/others.png');\n\t\t\t\t.img-content-custom{\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t#getContact {\n\t\t   background: #e2e6fb !important;\n\t\t   padding: 0;\n\t\t   text-align: center;\n\t\t   margin: 40px 0px !important;\n\t\t   .txt-content.custom {\n\t\t\t    width: 100%;\n\t\t\t    display: grid !important;\n\t\t\t    .btn-contact-us {\n\t\t\t    \tmargin: 30px 40px 0px 40px!important;\n\t\t\t    \tfont-size: 14px;\n\t\t\t    }\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include devices(miniTab tablet wideTablet) {\n\t.IndustrySectionOne{\n\t\tdisplay: flex !important;\n\t\tpadding: 0px !important;\n\t\tpadding-bottom: 40px !important;\n\t\tflex-direction: column !important;\n\t\t.IndustrySectionOne-left{\n\t\t\tdisplay: block !important;\n\t\t    width: 100%;\n\t\t    padding: 60px 30px;\n\t\t\t#IndustrySectionOne-left-head{\n\t\t    \tfont-size: 28px;\n\t\t    \tfont-weight: 700;\n\t\t    \tmargin-bottom: 20px;\n\t\t    \tmargin-top: 40px;\n\t\t    }\n\t\t    #IndustrySectionOne-left-middle{\n\t\t    \tdisplay: block !important;\n\t\t\t    width: 100%;\n\t\t\t    \n\t\t\t    #IndustrySectionOne-left-middle-left {\n\t\t\t    \tmargin-left: 0px;\n\t\t\t    \tfont-size: 16px;\n\t\t\t    \tline-height: 1.8;\n\t\t\t    }\n\t\t    }\n\t\t}\n\t\t.IndustrySectionOne-right{\n\t\t\tdisplay: flex;\n\t\t    position: relative !important;\n\t\t    width: 100%;\n\t\t    height: 230px;\n\t\t    float: right;\n\t\t    justify-content: flex-end;\n\t\t    align-items: end;\n\t\t    background: #f7ebd7;\n\t\t\tdiv{\n\t\t\t\tpadding: 0px 30px 10px 10px;\n\t\t\t\tbackground-color: #f7ebd7;\n\t\t\t\t.industry-image {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-height: 250px;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.IndustrySectionOne-Menu {\n\t\t.ui.secondary.pointing.menu {\n\t\t\toverflow: auto;\n    \t\twhite-space: nowrap;\n    \t\toverflow-y: hidden;\n    \t\t.item {\n    \t\t\tmargin: 0 5px;\n    \t\t\t.ui.header {\n    \t\t\t\tfont-size: 16px !important;\n    \t\t\t}\n    \t\t}\n\t\t}\n\t}\n\n\t.IndustrySectionOne-content-wrapper {\n\t\tpadding: 1px 30px 0;\n\t\t.section-custom {\n\t\t\tpadding: 100px 30px 0;\n\t\t\tjustify-content: flex-start;\n\t\t\t.content-wrapper-left {\n\t\t\t\t.header {\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\n\t\t\t\t.txt-content {\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\tul { padding-left: 30px; }\n\t\t\t\t\tul li {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t    line-height: 1.3;\n\t\t\t\t\t    margin-bottom: 15px;\n\t\t\t\t\t    font-weight: normal;\n\t\t\t\t\t}\n\t\t\t\t\t.discover-link {\n\t\t\t\t\t\tmargin-top: 30px;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.content-wrapper-right {\n\t\t\t\twidth: 50%;\n    \t\t\tmargin-left: 40px;\n\t\t\t\t.img-content {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-width: 350px;\n    \t\t\t\tmax-height: 240px;\n\t\t\t\t}\n\t\t\t\t.header {\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\n\t\t\t\t.txt-content {\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\tul { padding-left: 30px; }\n\t\t\t\t\tul li {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t    line-height: 1.3;\n\t\t\t\t\t    margin-bottom: 15px;\n\t\t\t\t\t    font-weight: normal;\n\t\t\t\t\t}\n\t\t\t\t\t.discover-link {\n\t\t\t\t\t\tmargin-top: 30px;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.img-content-renew, .img-content-private, .img-content-custom {\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 350px;\n\t\t\t\tmax-height: 240px;\n\t\t\t\tmargin-left: -12px;\n\t\t\t}\n\t\t\t.img-content-others {\n\t\t\t\tmargin-left: 2px;\n\t\t\t}\n\t\t\t.content-wrapper-left.custom {\n\t\t\t\twidth: 50%;\n\t\t\t}\n\t\t\t.content-wrapper-left.custom.getContact {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t.txt-content.custom {\n\t\t\t\tfont-size: 16px;\n\t\t\t    line-height: 1.8;\n\t\t\t    margin-bottom: 15px;\n\t\t\t    font-weight: normal;\n\t\t\t    margin-left: 0;\n\t\t\t    width: 100%;\n\t\t\t}\n\t\t\t.img-content-oil, .img-content-bank, .content-bank {\n\t\t\t\tpadding-left: 0;\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t\t#getContact .txt-content.custom {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t.btn-contact-us {\n\t\t\t\tmargin-left: 50px;\n\t\t\t\twidth: 75%;\n    \t\t\tmax-width: 130px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include devices(customTablet wideTablet) {\n\t.IndustrySectionOne{\n\t\tdisplay: flex !important;\n\t\tpadding: 70px 30px 50px !important;\n\t\tflex-direction: row !important;\n\t\t.IndustrySectionOne-left{\n\t\t    width: 90%;\n\t\t    padding: 0;\n\t\t    margin-right: 30px;\n\t\t\t#IndustrySectionOne-left-head{\n\t\t    \tfont-size: 28px;\n\t\t    \tfont-weight: 500;\n\t\t    \tmargin-bottom: 20px;\n\t\t    \tmargin-top: 40px;\n\t\t    }\n\t\t    #IndustrySectionOne-left-middle{\n\t\t    \tdisplay: block !important;\n\t\t\t    width: 100%;\n\t\t\t    \n\t\t\t    #IndustrySectionOne-left-middle-left {\n\t\t\t    \tmargin-left: 0px;\n\t\t\t    \tfont-size: 16px;\n\t\t\t    \tline-height: 1.8;\n\t\t\t    }\n\t\t    }\n\t\t}\n\t\t.IndustrySectionOne-right{\n\t\t\tdisplay: flex;\n\t\t    position: relative !important;\n\t\t    margin-top: -2px !important;\n    \t\tmargin-right: -30px;\n\t\t    width: 100%;\n\t\t    height: auto;\n\t\t    align-items: end;\n\t\t    justify-content: flex-start;\n\t\t    background: #f7ebd7;\n\t\t\tdiv{\n\t\t\t\tpadding: 0 !important;\n\t\t\t\tbackground-color: #f7ebd7;\n\t\t\t\t.industry-image {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-height: 300px;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\t\n}\n\n@include devices(customTablet) {\n\t.IndustrySectionOne-content-wrapper {\n\t\t.section-custom {\n\t\t\tpadding: 100px 50px 0 !important;\n\t\t}\n\t}\n}\n\n\n@include devices(wideTablet) {\n\t.IndustrySectionOne {\n\t\tpadding: 80px 60px 50px !important;\n\t\t.IndustrySectionOne-left {\n\t\t\t#IndustrySectionOne-left-head {\n\t\t\t\tmargin-top: 10%;\n\t\t\t}\n\t\t}\n\t\t.IndustrySectionOne-right {\n\t\t\tmargin-right: -60px !important;\n\t\t\tdiv{\n\t\t\t\t.industry-image {\n\t\t\t\t\tmax-height: 330px !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.IndustrySectionOne-Menu .ui.secondary.pointing.menu .item {\n\t\tmargin: 0 15px;\n\t}\n\n\t.IndustrySectionOne-content-wrapper {\n\t\t.section-custom {\n\t\t\tpadding: 100px 70px 0 !important;\n\t\t}\n\t\t.content-wrapper-right {\n\t\t\tmargin-left: 80px !important;\n\t\t\t.img-content {\n\t\t\t\tmax-width: 390px !important;\n\t\t\t\tmax-height: 280px !important;\n\t\t\t}\n\t\t}\n\t\t.img-content-renew, .img-content-private, .img-content-custom {\n\t\t\tmax-width: 390px !important;\n\t\t\tmax-height: 280px !important;\n\t\t}\n\t\t#getContact .txt-content.custom .btn-contact-us {\n\t\t\tmargin-left: 150px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
